import { render, staticRenderFns } from "./idolMonthIncomeAudit.vue?vue&type=template&id=0b512828&scoped=true"
import script from "./idolMonthIncomeAudit.vue?vue&type=script&lang=ts"
export * from "./idolMonthIncomeAudit.vue?vue&type=script&lang=ts"
import style0 from "./idolMonthIncomeAudit.vue?vue&type=style&index=0&id=0b512828&prod&scoped=true&lang=stylus"
import style1 from "./idolMonthIncomeAudit.vue?vue&type=style&index=1&id=0b512828&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b512828",
  null
  
)

export default component.exports